import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {DefaultDataServiceConfig, Logger} from '@ngrx/data';
import {AccountingAccountModel} from '../../../api/entity/accountingAccount.model';
import {AbstractDataServiceV2} from '../../../../../core/service/v2/dataservice/abstractDataServiceV2';
import {AccountingAccountConverter} from '../../../api/entity/converter/accountingAccount.converter';
import {CustomizeHttpUrlGenerator} from '../../../../../../store/core/url/customizeHttpUrlGenerator';


@Injectable({providedIn: 'root'})
export class AccountingAccountDataService extends AbstractDataServiceV2<AccountingAccountModel, AccountingAccountConverter> {
    constructor(http: HttpClient, httpUrlGenerator: CustomizeHttpUrlGenerator,
                logger: Logger, config: DefaultDataServiceConfig,
                converter: AccountingAccountConverter) {
        super('AccountingAccount', http, httpUrlGenerator, logger, config, converter);
    }
}
